module.exports = __webpack_public_path__ + "media/images/bg-enlightenment-8e51542bff51471b2d813a2d6a33239b.png";